import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';

import SimplivLink from 'Components/Order/SimplivLink';
import RedeemKeyLink from 'Components/Order/RedeemKeyLink';
import store from 'Redux/store';
import { addVoucher } from 'Redux/ducks/voucher';

export default function CopyKey({
  keyString,
  drm,
  bundleID,
  pid,
  externalRedeemLink: _externalRedeemLink,
  appendRevealedKey,
  setVoucherError,
  onCopy,
}) {
  let externalRedeemLink = _externalRedeemLink;

  if (drm === 'xbox' || drm === 'microsoft') {
    externalRedeemLink = 'https://redeem.microsoft.com';
  }

  if (drm === 'drivethrurpg') {
    externalRedeemLink = `https://www.drivethrurpg.com/browse.php?discount=${keyString}`;
  }

  if (drm === 'idw') {
    externalRedeemLink = 'https://apps.apple.com/us/app/idw-digital-comics-experience/id335630043';
  }

  const applyVoucher = async (code) => {
    const appliedVoucher = await store.dispatch(addVoucher(code));
    if (isEmpty(appliedVoucher)) setVoucherError(true);
  };

  if (bundleID === '606ed0be9c233e007d2bfb51' || bundleID === '6076f01665b26d007d6329e9') {
    return <SimplivLink pid={pid} itemKey={keyString} onCopy={onCopy} />;
  }

  if (bundleID === '60a4cb531926c90076d0ba93') {
    return <RedeemKeyLink itemKey={keyString} supplierLink="http://aaspack.com" onCopy={onCopy} />;
  }

  if (includes(keyString, 'https://')) {
    return (<a href={keyString} target="_blank" rel="noopener noreferrer" className="btn btn-primary"><FormattedMessage id="reveal-key.button.redeem" defaultMessage="Redeem" /></a>);
  }

  if (drm === 'steam') {
    return (
      <Button href={`https://store.steampowered.com/account/registerkey?key=${keyString}`} target="_blank" color="primary">
        <FormattedMessage id="reveal-key.button.redeem.steam" defaultMessage="Redeem on Steam" />
      </Button>
    );
  }

  if (drm === 'redeem') {
    return (
      <Link
        to={`/redeem-code?code=${keyString}`}
        className="btn btn-fanatical-secondary"
      >
        <FormattedMessage id="reveal-key.button.redeem-code" defaultMessage="Use Redeem Code" />
      </Link>
    );
  }

  if (externalRedeemLink) {
    return (
      <React.Fragment>
        {appendRevealedKey ?
          <RedeemKeyLink itemKey={keyString} supplierLink={externalRedeemLink} onCopy={onCopy} />
          :
          <CopyToClipboard text={keyString} onCopy={onCopy}>
            <a href={externalRedeemLink} alt="alt" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              <FormattedMessage id="reveal-key.copyandredeem" defaultMessage="Copy & Redeem" />
            </a>
          </CopyToClipboard>
        }
      </React.Fragment>
    );
  }

  if (drm === 'coupon' || drm === 'voucher') {
    return (
      <button className="btn btn-primary" onClick={() => { applyVoucher(keyString); }}>
        <FormattedMessage id="reveal-key.button.coupon" defaultMessage="Apply Coupon" />
      </button>
    );
  }

  return (
    <CopyToClipboard text={keyString} onCopy={onCopy}>
      <Button color="primary"><FormattedMessage id="reveal-key.copy" defaultMessage="Copy" /></Button>
    </CopyToClipboard>
  );
}

CopyKey.propTypes = {
  onCopy: PropTypes.func.isRequired,
  setVoucherError: PropTypes.func.isRequired,
  keyString: PropTypes.string.isRequired,
  bundleID: PropTypes.string,
  pid: PropTypes.string.isRequired,
  drm: PropTypes.string,
  externalRedeemLink: PropTypes.string,
  appendRevealedKey: PropTypes.bool,
};

CopyKey.defaultProps = {
  bundleID: null,
  drm: '',
  externalRedeemLink: '',
  isCoupon: false,
  appendRevealedKey: false,
};
